/**
 * confirmDialog — confirmation modale, promise-based, appelable de n'importe où.
 *
 *   if (!(await confirmDialog('Supprimer ce contact ?'))) return;
 *   await confirmDialog('Tout supprimer ?', { title: 'Suppression', danger: true });
 *
 * Renvoie une Promise<boolean>. Un seul <ConfirmDialog /> (racine) sert les requêtes.
 * Repli sur la confirmation native si l'hôte n'est pas monté (sécurité).
 */
let host = null;

export function confirmDialog(message, opts = {}) {
  return new Promise((resolve) => {
    if (!host) {
      // eslint-disable-next-line no-alert
      resolve(window.confirm(String(message)));
      return;
    }
    host({
      message: String(message),
      title: opts.title || 'Confirmation',
      confirmLabel: opts.confirmLabel || 'Confirmer',
      cancelLabel: opts.cancelLabel || 'Annuler',
      danger: opts.danger || false,
      resolve,
    });
  });
}

export function promptDialog(message, opts = {}) {
  return new Promise((resolve) => {
    if (!host) {
      // eslint-disable-next-line no-alert
      resolve(window.prompt(String(message), opts.defaultValue || ''));
      return;
    }
    host({
      message: String(message),
      title: opts.title || 'Saisie',
      confirmLabel: opts.confirmLabel || 'Valider',
      cancelLabel: opts.cancelLabel || 'Annuler',
      danger: false,
      input: true,
      defaultValue: opts.defaultValue || '',
      placeholder: opts.placeholder || '',
      resolve,
    });
  });
}

export function registerConfirmHost(fn) {
  host = fn;
  return () => { if (host === fn) host = null; };
}
